<template>
  <div class="ownerEvaluationLists vheight">
    <div class="header-seacher" v-resize="redraw" :inline="true">
      <div class="ub" id="moveHeight">
        <div class="header-firstLine">
          <!-- <div class="administration" >
            <span>行政区域：</span>
            <el-cascader
              size="mini"
              v-model="value"
              :options="options"
              @change="handleChange"
              change-on-select
              filterable
            ></el-cascader>
          </div>-->
          <div class="evaluateObjType">
            <span class>评价类型：</span>
            <el-select placeholder="请选择" v-model="evaluateObjType" size="mini">
              <el-option
                v-for="(item,index) in evaluateObjTypes"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="Datetime">
            <span>日期：</span>
            <el-date-picker
              v-model="month"
              size="mini"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月"
            ></el-date-picker>
          </div>
          <div class="searchButton" style="width:240px;">
            <ps-search @click="search()"></ps-search>
            <ps-clear @click="clear()"></ps-clear>
          </div>
        </div>
      </div>
    </div>
    <div class="container" :style="{height:'calc(100% - 55px - '+headerHeight+'px )'}">
      <div class="container-header"></div>
      <div class="grid">
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;"
          height="100%"
          stripe
          border
          :highlight-current-row="true"
          @cell-dblclick="tableDoubleClick"
        >
          <el-table-column
            prop="Rank"
            label="排名"
            min-width="60"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="OrgName"
            label="机构名称"
            width="600"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>

          <el-table-column
            prop="Average"
            label="平均得分"
            min-width="60"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">{{scope.row.Average.toFixed(2)}}</template>
          </el-table-column>
          <!-- <el-table-column fixed="right" align="center" label="操作" width="180">
            <template slot-scope="scope">
              <ps-detail @click="tableDoubleClick(scope.row)"></ps-detail>
            </template>
          </el-table-column>-->
          <el-table-column
            label="环比"
            min-width="60"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.RankChange > 0" class="el-icon-back incre"></span>
              <span v-if="scope.row.RankChange < 0" class="el-icon-back decre"></span>
              <span v-if="scope.row.RankChange === 0" class="el-icon-minus equal"></span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="60" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <el-button @click.native.prevent="detailsRow(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer">
      <div class="fun">
        <!-- <span @click="tablechoose(true)">全选</span>

        <span @click="tablechoose(false)">反选</span>
        <span class="delete">删除</span>-->
      </div>
      <div class="page">
        <ps-page :page="pages" @getData="getData()"></ps-page>
      </div>
    </div>
  </div>
</template>

<script>
import { OpenControllerSvr } from "@/service/OpenControllerSvr/OpenControllerSvr";
import { EvaluteResultController } from "@/service/EvaluteResultController/EvaluteResultController";
import { Page } from "@/models/page";
import { mapState } from "vuex";
import { EaAreaControllerSvr } from "@/service/EaAreaControllerSvr.js";
import { AuthenticationControllerSvr } from "@/service/AuthenticationControllerSvr.js";
import { CommonControllerSvr } from "@/service/CommonControllerSvr/CommonControllerSvr";
import { division } from "@/assets/js/division";
import { EvaluateRankResultQueryPara } from "@/service/EvaluteResultController/EvaluateRankResultQueryPara.js";
import { headerredraw } from "@/mixin/headerredraw";
import { identityEnum } from "@/enum/identityEnum";

export default {
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      value: [],
      options: [],
      Sightlength: "",
      cantonCode: "",
      streetOfficeOrgCode: "",
      residentsCommitteeOrgCode: "",
      month: "",
      loading: false,
      tableData: [],
      identityEnum: new identityEnum(),
      evaluteResultController: new EvaluteResultController(),
      evaluateRankResultQueryPara: new EvaluateRankResultQueryPara(),
      pages: new Page(),
      showConton: false,
      evaluateObjType: 1,
      evaluateObjTypes: [
        {
          label: "业委会",
          value: 2
        },
        {
          label: "物管企业",
          value: 1
        }
      ]
    };
  },
  computed: {
    ...mapState(["token", "userInfo"])
  },
  created() {
    this.getUserDeatil();
    this.openControllerSvr = new OpenControllerSvr();
    this.CommonControllerSvr = new CommonControllerSvr();
    this.getDateTime();
  },
  mounted() {
    this.getData();
  },
  methods: {
    detailsRow(row) {
      this.$router.push({
        path: "/PropertyProjectList",
        query: {
          OrgCode: row.OrgCode,
          Year: row.Year,
          Month: row.Month,
          OrgName: row.OrgName
        }
      });
    },
    indexMethod(index) {
      return index + 1 + (this.pages.currentPage - 1) * this.pages.currtNum;
    }, //初始化日期查询条件
    getDateTime() {
      let _date = new Date();
      if (_date.getMonth() < 10) {
        if (_date.getMonth() === 0) {
          this.month = _date.getFullYear() - 1 + "-12";
        } else {
          this.month = _date.getFullYear() + "-0" + _date.getMonth();
        }
      } else {
        this.month = _date.getFullYear() + "-" + _date.getMonth();
      }
    }, //初始化用户信息
    getUserDeatil() {},
    handleChange(value) {
      //this.Sightlength为3代表权限等级到区2街道1居委会
      if (this.Sightlength === 3) {
        this.cantonCode = value[0];
        this.streetOfficeOrgCode = value[1] || "";
        this.residentsCommitteeOrgCode = value[2] || "";
        if (this.residentsCommitteeOrgCode) {
          this.cantonCode = "";
          this.streetOfficeOrgCode = "";
        } else if (this.streetOfficeOrgCode) {
          this.cantonCode = "";
        }
      } else if (this.Sightlength === 2) {
        this.cantonCode = "";
        this.streetOfficeOrgCode = value[0] || "";
        this.residentsCommitteeOrgCode = value[1] || "";
        if (this.residentsCommitteeOrgCode) {
          this.streetOfficeOrgCode = "";
        }
      } else if (this.Sightlength === 1) {
        this.cantonCode = "";
        this.streetOfficeOrgCode = "";
        this.residentsCommitteeOrgCode = value[0] || "";
      }
    },
    clear() {
      this.getDateTime();
      this.evaluateObjType = 1;
      this.cantonCode = "";
      this.value = [];
      this.streetOfficeOrgCode = "";
      this.residentsCommitteeOrgCode = "";
      this.getUserDeatil();
      this.getData();
    },
    search() {
      this.pages.currentPage = 1;
      this.getData();
    },
    tableDoubleClick(row) {
      this.$router.push({
        path: "/PropertyProjectList",
        query: {
          OrgCode: row.OrgCode,
          Year: row.Year,
          Month: row.Month,
          OrgName: row.OrgName
        }
      });
    },
    getData() {
      this.loading = true;
      this.evaluteResultController
        .GetRankInfoList(
          this.month.split("-")[0],
          this.month.split("-")[1],
          this.evaluateObjType,
          this.cantonCode,
          this.streetOfficeOrgCode,
          this.residentsCommitteeOrgCode,
          (this.pages.currentPage - 1) * this.pages.currtNum,
          this.pages.currtNum,
          this.$route.query.isBoolType && this.$route.query.isBoolType == 2 ? false : true
        )
        .then(res => {
          this.tableData = res._Items;
          this.pages.getCurrtNum = res.TotalCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" >
.ownerEvaluationLists {
  .el-table--border {
    min-height: 300px;
  }
  .container {
    width: 50%;
  }
  .administration {
    .el-cascader {
      .el-input {
        width: 400px !important;
        .el-input__inner {
          width: 400px !important;
        }
      }
    }
  }
  .evaluateObjType {
    .el-select {
      width: 100px !important;
      .el-input {
        width: 100px !important;
      }
    }
  }
  .Datetime {
    .el-input {
      width: 120px !important;
      .el-input__suffix-inner {
        display: none;
      }
    }
  }
}

.el-cascader-menu {
  width: auto;
  .el-cascader-menu__item {
    padding: 8px 40px 8px 20px;
  }
}
.el-cascader-menu__item--extensible:after {
  font-family: element-icons;
  content: "\E604";
  font-size: 14px;
  color: #bfcbd9;
  position: absolute;
  right: 10px;
}
</style>
<style lang="scss" scoped>
.ownerEvaluationLists {
  .footer {
    width: 100%;
  }
  .incre {
    transform: rotate(90deg);
    color: #7cc562;
  }
  .decre {
    transform: rotate(-90deg);
    color: #ff4546;
  }
  .equal {
    color: #ffb11a;
  }
}
</style>